import React from "react";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Avatar,
    Chip,
    LinearProgress,
    Divider,
} from "@mui/material";

import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

export const Dashboard = () => {

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "1600px",
                margin: "0 auto",
            }}
        >

            {/* =====================================================
                ENCABEZADO
            ===================================================== */}

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: {
                        xs: "flex-start",
                        md: "center",
                    },
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    gap: 2,
                    mb: 4,
                }}
            >

                <Box>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "1.6rem",
                                md: "2rem",
                            },
                            fontWeight: 700,
                            color: "#22324A",
                            mb: 0.5,
                        }}
                    >
                        Panel de Administración
                    </Typography>

                    <Typography
                        sx={{
                            color: "#737A86",
                            fontSize: "0.95rem",
                        }}
                    >
                        Gestiona y administra el contenido del
                        Colegio Antilen.
                    </Typography>

                </Box>

                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                    }}
                >

                    <Button
                        variant="outlined"
                        startIcon={
                            <WebOutlinedIcon />
                        }
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            borderColor: "#D9DEE7",
                            color: "#22324A",
                        }}
                    >
                        Ver sitio web
                    </Button>

                    <Button
                        variant="contained"
                        startIcon={
                            <AddOutlinedIcon />
                        }
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#22324A",

                            "&:hover": {
                                backgroundColor: "#182536",
                            },
                        }}
                    >
                        Nueva noticia
                    </Button>

                </Box>

            </Box>


            {/* =====================================================
                BANNER BIENVENIDA
            ===================================================== */}

            <Card
                sx={{
                    borderRadius: 4,
                    mb: 3,
                    overflow: "hidden",
                    border: "1px solid #E7EAF0",
                    boxShadow:
                        "0 8px 30px rgba(34,50,74,0.06)",
                }}
            >

                <Box
                    sx={{
                        background:
                            "linear-gradient(135deg, #22324A 0%, #314A68 100%)",

                        minHeight: 190,

                        display: "flex",
                        alignItems: "center",

                        px: {
                            xs: 3,
                            md: 5,
                        },

                        py: 4,

                        position: "relative",
                        overflow: "hidden",
                    }}
                >

                    {/* Decoración */}

                    <Box
                        sx={{
                            position: "absolute",
                            width: 260,
                            height: 260,
                            borderRadius: "50%",
                            background:
                                "rgba(255,255,255,0.04)",
                            right: -70,
                            top: -100,
                        }}
                    />

                    <Box
                        sx={{
                            position: "absolute",
                            width: 180,
                            height: 180,
                            borderRadius: "50%",
                            background:
                                "rgba(255,255,255,0.03)",
                            right: 150,
                            bottom: -120,
                        }}
                    />

                    <Box
                        sx={{
                            position: "relative",
                            zIndex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >

                        <Avatar
                            sx={{
                                width: 72,
                                height: 72,
                                backgroundColor:
                                    "rgba(255,255,255,0.12)",
                                border:
                                    "1px solid rgba(255,255,255,0.2)",
                            }}
                        >
                            <SchoolOutlinedIcon
                                sx={{
                                    fontSize: 38,
                                    color: "#fff",
                                }}
                            />
                        </Avatar>

                        <Box>

                            <Typography
                                sx={{
                                    color: "#BFC9D6",
                                    fontSize: "0.85rem",
                                    mb: 0.5,
                                }}
                            >
                                SISTEMA DE ADMINISTRACIÓN
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 700,
                                    fontSize: {
                                        xs: "1.5rem",
                                        md: "2rem",
                                    },
                                }}
                            >
                                Colegio Antilen
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#D8DEE6",
                                    fontSize: "0.9rem",
                                    mt: 0.5,
                                }}
                            >
                                Bienvenido al panel de administración
                            </Typography>

                        </Box>

                    </Box>

                </Box>

            </Card>


            {/* =====================================================
                ESTADÍSTICAS
            ===================================================== */}

            <Grid
                container
                spacing={2.5}
                sx={{ mb: 3 }}
            >

                {/* Noticias */}

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3,
                    }}
                >

                    <StatCard
                        icon={
                            <NewspaperOutlinedIcon />
                        }
                        title="Noticias"
                        value="24"
                        description="Publicaciones"
                        iconBackground="#EAF1F8"
                        iconColor="#315A80"
                    />

                </Grid>


                {/* Documentos */}

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3,
                    }}
                >

                    <StatCard
                        icon={
                            <DescriptionOutlinedIcon />
                        }
                        title="Documentos"
                        value="18"
                        description="Documentos publicados"
                        iconBackground="#EEF5EF"
                        iconColor="#46704F"
                    />

                </Grid>


                {/* Comunidad */}

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3,
                    }}
                >

                    <StatCard
                        icon={
                            <GroupsOutlinedIcon />
                        }
                        title="Comunidad"
                        value="12"
                        description="Secciones activas"
                        iconBackground="#F5F0E8"
                        iconColor="#826A3C"
                    />

                </Grid>


                {/* Personal */}

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3,
                    }}
                >

                    <StatCard
                        icon={
                            <PersonOutlineOutlinedIcon />
                        }
                        title="Personal"
                        value="32"
                        description="Personas registradas"
                        iconBackground="#F1ECF7"
                        iconColor="#66507C"
                    />

                </Grid>

            </Grid>


            {/* =====================================================
                CONTENIDO PRINCIPAL
            ===================================================== */}

            <Grid
                container
                spacing={2.5}
            >

                {/* ACTIVIDAD */}

                <Grid
                    size={{
                        xs: 12,
                        lg: 8,
                    }}
                >

                    <Card
                        sx={{
                            borderRadius: 3,
                            border:
                                "1px solid #E7EAF0",
                            boxShadow: "none",
                            height: "100%",
                        }}
                    >

                        <CardContent sx={{ p: 3 }}>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent:
                                        "space-between",
                                    alignItems:
                                        "center",
                                    mb: 3,
                                }}
                            >

                                <Box>

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize:
                                                "1.05rem",
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        Actividad reciente
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "0.8rem",
                                            color:
                                                "#858C97",
                                        }}
                                    >
                                        Últimos movimientos
                                        realizados
                                    </Typography>

                                </Box>

                                <TrendingUpOutlinedIcon
                                    sx={{
                                        color:
                                            "#22324A",
                                    }}
                                />

                            </Box>


                            <ActivityItem
                                icon={
                                    <NewspaperOutlinedIcon />
                                }
                                title="Nueva noticia publicada"
                                description="Se publicó una nueva noticia en el sitio web."
                                time="Hace 20 minutos"
                            />

                            <ActivityItem
                                icon={
                                    <DescriptionOutlinedIcon />
                                }
                                title="Documento actualizado"
                                description="Se actualizó un documento institucional."
                                time="Hace 1 hora"
                            />

                            <ActivityItem
                                icon={
                                    <WebOutlinedIcon />
                                }
                                title="Contenido actualizado"
                                description="Se modificó información de la página."
                                time="Hace 3 horas"
                            />

                            <ActivityItem
                                icon={
                                    <PersonOutlineOutlinedIcon />
                                }
                                title="Personal actualizado"
                                description="Se modificó información del personal."
                                time="Ayer"
                                last
                            />

                        </CardContent>

                    </Card>

                </Grid>


                {/* ACCESOS RÁPIDOS */}

                <Grid
                    size={{
                        xs: 12,
                        lg: 4,
                    }}
                >

                    <Card
                        sx={{
                            borderRadius: 3,
                            border:
                                "1px solid #E7EAF0",
                            boxShadow: "none",
                            height: "100%",
                        }}
                    >

                        <CardContent sx={{ p: 3 }}>

                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize:
                                        "1.05rem",
                                    color:
                                        "#22324A",
                                }}
                            >
                                Accesos rápidos
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize:
                                        "0.8rem",
                                    color:
                                        "#858C97",
                                    mb: 2.5,
                                }}
                            >
                                Administración del sitio
                            </Typography>


                            <QuickAction
                                icon={
                                    <NewspaperOutlinedIcon />
                                }
                                title="Gestionar noticias"
                                description="Crear y editar noticias"
                            />

                            <QuickAction
                                icon={
                                    <DescriptionOutlinedIcon />
                                }
                                title="Documentos"
                                description="Administrar documentos"
                            />

                            <QuickAction
                                icon={
                                    <GroupsOutlinedIcon />
                                }
                                title="Comunidad"
                                description="Gestionar contenido"
                            />

                            <QuickAction
                                icon={
                                    <PersonOutlineOutlinedIcon />
                                }
                                title="Personal"
                                description="Administrar personal"
                            />

                        </CardContent>

                    </Card>

                </Grid>


                {/* ESTADO DEL SITIO */}

                <Grid
                    size={{
                        xs: 12,
                    }}
                >

                    <Card
                        sx={{
                            borderRadius: 3,
                            border:
                                "1px solid #E7EAF0",
                            boxShadow: "none",
                        }}
                    >

                        <CardContent sx={{ p: 3 }}>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent:
                                        "space-between",
                                    alignItems:
                                        "center",
                                    mb: 3,
                                }}
                            >

                                <Box>

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        Estado del sitio web
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "0.8rem",
                                            color:
                                                "#858C97",
                                        }}
                                    >
                                        Información general
                                    </Typography>

                                </Box>

                                <Chip
                                    label="Sitio activo"
                                    size="small"
                                    sx={{
                                        backgroundColor:
                                            "#E8F5EC",
                                        color:
                                            "#367047",
                                        fontWeight: 600,
                                    }}
                                />

                            </Box>


                            <Grid
                                container
                                spacing={3}
                            >

                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 4,
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "0.75rem",
                                            color:
                                                "#858C97",
                                            mb: 1,
                                        }}
                                    >
                                        CONTENIDO PUBLICADO
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "1.5rem",
                                            fontWeight: 700,
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        82%
                                    </Typography>

                                    <LinearProgress
                                        variant="determinate"
                                        value={82}
                                        sx={{
                                            mt: 1,
                                            height: 6,
                                            borderRadius: 5,
                                        }}
                                    />

                                </Grid>


                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 4,
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "0.75rem",
                                            color:
                                                "#858C97",
                                            mb: 1,
                                        }}
                                    >
                                        ÚLTIMA ACTUALIZACIÓN
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "1rem",
                                            fontWeight: 600,
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        Hoy, 14:35
                                    </Typography>

                                </Grid>


                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 4,
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            fontSize:
                                                "0.75rem",
                                            color:
                                                "#858C97",
                                            mb: 1,
                                        }}
                                    >
                                        ESTADO DEL SISTEMA
                                    </Typography>

                                    <Box
                                        sx={{
                                            display:
                                                "flex",
                                            alignItems:
                                                "center",
                                            gap: 1,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                width: 9,
                                                height: 9,
                                                borderRadius:
                                                    "50%",
                                                backgroundColor:
                                                    "#3B8E50",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                fontWeight:
                                                    600,
                                                color:
                                                    "#367047",
                                            }}
                                        >
                                            Funcionando
                                            correctamente
                                        </Typography>

                                    </Box>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

            </Grid>

        </Box>
    );
};


/* ============================================================
   COMPONENTE ESTADÍSTICA
============================================================ */

const StatCard = ({
    icon,
    title,
    value,
    description,
    iconBackground,
    iconColor,
}) => {

    return (
        <Card
            sx={{
                borderRadius: 3,
                border: "1px solid #E7EAF0",
                boxShadow: "none",
                height: "100%",
            }}
        >

            <CardContent sx={{ p: 2.5 }}>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems: "flex-start",
                    }}
                >

                    <Box>

                        <Typography
                            sx={{
                                fontSize: "0.8rem",
                                color: "#858C97",
                                mb: 1,
                            }}
                        >
                            {title}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "1.8rem",
                                fontWeight: 700,
                                color: "#22324A",
                            }}
                        >
                            {value}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "0.75rem",
                                color: "#858C97",
                                mt: 0.5,
                            }}
                        >
                            {description}
                        </Typography>

                    </Box>

                    <Avatar
                        sx={{
                            backgroundColor:
                                iconBackground,
                            color: iconColor,
                            width: 45,
                            height: 45,
                        }}
                    >
                        {icon}
                    </Avatar>

                </Box>

            </CardContent>

        </Card>
    );
};


/* ============================================================
   ACTIVIDAD
============================================================ */

const ActivityItem = ({
    icon,
    title,
    description,
    time,
    last,
}) => {

    return (
        <Box
            sx={{
                display: "flex",
                gap: 2,
                pb: last ? 0 : 2.2,
                mb: last ? 0 : 2.2,
                borderBottom: last
                    ? "none"
                    : "1px solid #EEF0F4",
            }}
        >

            <Avatar
                sx={{
                    width: 38,
                    height: 38,
                    backgroundColor:
                        "#EEF2F6",
                    color: "#31516F",
                }}
            >
                {icon}
            </Avatar>

            <Box sx={{ flex: 1 }}>

                <Typography
                    sx={{
                        fontSize: "0.85rem",
                        fontWeight: 600,
                        color: "#22324A",
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        fontSize: "0.78rem",
                        color: "#858C97",
                        mt: 0.3,
                    }}
                >
                    {description}
                </Typography>

                <Typography
                    sx={{
                        fontSize: "0.7rem",
                        color: "#A0A6AF",
                        mt: 0.5,
                    }}
                >
                    {time}
                </Typography>

            </Box>

        </Box>
    );
};


/* ============================================================
   ACCESO RÁPIDO
============================================================ */

const QuickAction = ({
    icon,
    title,
    description,
}) => {

    return (
        <Button
            fullWidth
            sx={{
                justifyContent: "flex-start",
                textAlign: "left",
                textTransform: "none",
                color: "#22324A",
                p: 1.2,
                mb: 0.7,
                borderRadius: 2,

                "&:hover": {
                    backgroundColor: "#F5F7FA",
                },
            }}
        >

            <Avatar
                sx={{
                    width: 38,
                    height: 38,
                    mr: 1.5,
                    backgroundColor:
                        "#EEF2F6",
                    color: "#31516F",
                }}
            >
                {icon}
            </Avatar>

            <Box sx={{ flex: 1 }}>

                <Typography
                    sx={{
                        fontSize: "0.82rem",
                        fontWeight: 600,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        fontSize: "0.7rem",
                        color: "#858C97",
                    }}
                >
                    {description}
                </Typography>

            </Box>

            <ArrowForwardIcon
                sx={{
                    fontSize: 17,
                    color: "#A0A6AF",
                }}
            />

        </Button>
    );
};

export default Dashboard;